import ReactDOM from 'react-dom/client';

// Importation du composant principal de l'application.
import App from './App';

// Rendu de l'application dans le DOM,
// ciblant un élément div spécifique dans le body.
ReactDOM.createRoot(
    document.querySelector('body > div') as HTMLElement
).render(
    <App />
);